export const WORKSPACE_TABLE_HEADERS = [
  { name: 'Workspace Name', classOverride: 'w-[calc(100%-39%)]' },
  { name: 'Creator', classOverride: 'w-[15%]' },
  { name: 'Date Created', classOverride: 'w-[15%]' },
  { name: 'No. of users', classOverride: 'w-[10%]' },
  { name: 'Action', classOverride: 'w-[10%]' },
];

export const BULK_REPORTS_TABLE_HEADERS = [
  { name: 'File Name', classOverride: 'w-[30%]' },
  { name: 'User Name', classOverride: 'w-[20%]' },
  { name: 'Status', classOverride: 'w-[25%]' },
  { name: 'Action', classOverride: 'w-[25%]' },
];

export const WORKSPACE_CONSTANTS = {
  deactivateMessage:
    'Are you sure you want to deactivate this item? You can reactivate it later if needed.',
  activateMessage:
    'Are you sure you want to activate this item? This will make it available for use.',
  Cancel: ' No, Cancel',
};

export const MAX_CSV_FILE_SIZE = 5 * 1024 * 1024;

export const BulkCreationReportStatusMap: Record<number, string> = {
  1: 'Processing',
  2: 'Processing',
  3: 'Failed',
  4: 'Success',
  5: 'Binned',
  6: 'Timeout',
  7: 'Partial Success',
  8: 'Validating',
  9: 'Invalid',
};

export const BULK_WORKSPACE_CREATION_FAILED_STATUS = 3;
export const BULK_WORKSPACE_CREATION_SUCCESS_STATUS = 4;
export const BULK_WORKSPACE_CREATION_PARTIAL_SUCCESS_STATUS = 7;
